var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJodFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.006 0h90v15.003h-90V0Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.006 15.003h90v14.994h-90V15.003Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.006 29.997h90V45h-90V29.997Z",
    fill: "#090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.006 45 45-22.5L.006 0v45Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.513 25.4.5-2.188h-2.24l2.02-.967-1.396-1.749 2.021.967.492-2.18.501 2.189 2.013-.976-1.406 1.75 2.021.966h-2.232l.5 2.188-1.397-1.757-1.397 1.757Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJodFlag);
export default __webpack_public_path__ + "static/media/jod-flag.33640274c3842474844a9fb1a8842b20.svg";
export { ForwardRef as ReactComponent };